import cn from 'classnames';
import { Form, Core, Drawer } from 'connex-cds';
import { isEmpty } from 'lodash';
import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { FLOW } from '../Acceptance';
import style from './style';
import { useCompanySetup } from '../../../../MasterDataProvider';
import { LoadRejection } from '../../../../LoadRejection';
import { useViewport } from '../../../../../../../../util/useViewport';

const Styled = styled.div`
  ${style}
`;
export const FinalizeActionsDesktop = ({
  finalized,
  flow,
  handleAcceptClick,
  handleRejectClick,
  handleClick,
  errors,
}) => {
  const location = useLocation();
  const { Components, setFieldValue, values, isSubmitting } = Form.useFormContext();
  const companySetup = useCompanySetup();
  const { openDrawer, closeDrawer } = Drawer.useDrawerContext();
  const dimensions = useViewport();

  const isEarlyAcceptance = React.useMemo(() => {
    if (!companySetup?.data?.isEarlySignatureEnabled) {
      return false;
    }

    const searchParams = new URLSearchParams(location?.search);
    return searchParams.get('showEarlyAcceptance') ?? false;
  }, [location?.search, companySetup?.data?.isEarlySignatureEnabled]);

  React.useEffect(() => {
    if (isEarlyAcceptance) {
      handleClick();
    }
  }, [isEarlyAcceptance, handleClick]);

  const handleCancel = React.useCallback(() => {
    setFieldValue('customerRejectReason', undefined);
    setFieldValue('customerStatus', 'PENDING');
    closeDrawer();
  }, [closeDrawer, setFieldValue]);

  const onSubmit = React.useCallback(() => {
    openDrawer({
      titleStringId: 'driverRejection',
      component: <LoadRejection />,
      width: Math.min(750, dimensions?.width),
      onClose: handleCancel,
    });
  }, [dimensions?.width, handleCancel, openDrawer]);

  return finalized ? (
    <Styled className={cn('finalize-actions accept-reject')}>
      <div className="buttons-signature">
        {flow === FLOW.ACCEPT_REJECT ? (
          <Core.Button
            stringId="accept"
            onClick={handleAcceptClick}
            type="primary"
            data-testid="accept-button"
            disabled={values?.realTimeIsLoading}
            loading={values?.realTimeIsLoading}
          />
        ) : (
          <Core.Button
            stringId="signature"
            onClick={handleAcceptClick}
            type="primary"
            data-testid="accept-button"
            disabled={values?.realTimeIsLoading}
            loading={values?.realTimeIsLoading}
          />
        )}

        {flow === FLOW.ACCEPT_REJECT ? (
          <Core.Button
            danger
            stringId="reject"
            onClick={handleRejectClick}
            type="primary"
            data-testid="reject-button"
            disabled={values?.realTimeIsLoading}
            loading={values?.realTimeIsLoading}
          />
        ) : (
          <Components.SubmitButton
            stringId="no-signature"
            data-testid="no-signature-button"
            type="primary"
            danger
            disabledWhenNotDirty={false}
            disabled={
              isEarlyAcceptance
                ? true
                : !isEmpty(errors) ||
                  values?.realTimeIsLoading ||
                  companySetup?.data?.isNoSignatureOptionEnabled === false
            }
            loading={values?.realTimeIsLoading || isSubmitting}
          />
        )}
        {companySetup?.data?.isRejectLoadsEnable && companySetup?.data?.rejectLoadStep === 'returnedAndFinalize' && (
          <Core.Button
            danger
            stringId="reject"
            onClick={onSubmit}
            type="primary"
            data-testid="reject-button"
            disabled={isEarlyAcceptance ? true : values?.realTimeIsLoading}
            loading={values?.realTimeIsLoading}
          />
        )}
      </div>
    </Styled>
  ) : (
    <Styled className={cn('finalize-actions finalize')}>
      <div>
        <Core.Button
          className="finalizeButton"
          stringId="finalize"
          onClick={handleClick}
          type="primary"
          data-testid="finalize-button"
          disabled={values?.realTimeIsLoading}
          loading={values?.realTimeIsLoading}
        />
      </div>
    </Styled>
  );
};
